
// Constants for file upload validation and configuration

// Maximum file size in bytes (50MB)
export const MAX_FILE_SIZE = 50 * 1024 * 1024;

// Allowed MIME types
export const ALLOWED_MIME_TYPES = ['application/pdf'];

// Maximum uploads per hour per user (rate limiting)
export const MAX_UPLOADS_PER_HOUR = 10;
